function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { utils } from '../utils';

var MobileZoomImage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MobileZoomImage, _React$Component);

  function MobileZoomImage(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = MobileZoomImage.prototype;

  _proto.getResizedImage = function getResizedImage() {
    var item = this.props.item;
    var width = item.width,
        height = item.height;
    var style = {
      width: width,
      height: height,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    };
    return /*#__PURE__*/React.createElement("img", {
      src: this.props.resizedUrl,
      style: style
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        item = _this$props.item,
        currentWindow = _this$props.currentWindow;
    var maxWidth = item.maxWidth,
        maxHeight = item.maxHeight;
    var isLandscape = window.orientation === 90 || window.orientation === -90;
    var screenHeight = window.screen.height;
    var screenWidth = window.screen.width;
    var ratio = screenWidth / screenHeight;
    var cutByHeight = ratio > item.ratio;

    if (isLandscape && utils.isiOS()) {
      cutByHeight = !cutByHeight;
    }

    var scale = cutByHeight ? currentWindow.size.height / maxHeight : currentWindow.size.width / maxWidth;
    var imageStyles = {
      width: maxWidth,
      height: maxHeight,
      transform: "translate3d(-50%, -50%, 0) scale(" + scale + ")",
      position: 'absolute',
      left: '50%',
      top: '50%'
    };
    console.log('url ======= ', this.props.resizedUrl);
    return /*#__PURE__*/React.createElement("div", null, this.getResizedImage(), /*#__PURE__*/React.createElement("img", {
      key: 'idx',
      src: item.createUrl('full', 'img'),
      style: imageStyles
    }));
  };

  return MobileZoomImage;
}(React.Component);

export { MobileZoomImage as default };